module.exports = __webpack_public_path__ + "static/media/18ECA42.d1aaf5fc.jpg";